export const PHONEME_DATA_LIST = [
  {
    Id: 223250,
    Img: "314/223250/pid-3140017-223250-409271413.gif",
    symbol: "a",
    phoneme: "aa",
    Words: ["h<b>o</b>t"],
    Langs: 40160,
    AssignIds: [6134, 6127],
  },
  {
    Id: 223247,
    Img: "314/223247/pid-3140017-223247-408231251.gif",
    symbol: "ɛ",
    phoneme: "eh",
    Words: ["y<b>e</b>s"],
    Langs: 48859,
    AssignIds: [6128, 6141],
  },
  {
    Id: 222888,
    Img: "314/222888/pid-3140017-222888-408231232.gif",
    symbol: "i",
    phoneme: "iy",
    Words: ["s<b>ee</b>"],
    Langs: 8384,
    AssignIds: [6146],
  },
  {
    Id: 223249,
    Img: "314/223249/pid-3140017-223249-408231254.gif",
    symbol: "ʌ",
    phoneme: "ax",
    Words: ["b<b>u</b>s"],
    Langs: 61247,
    AssignIds: [6127],
  },
  {
    Id: 222969,
    Img: "314/222969/pid-3140017-222969-408231252.gif",
    symbol: "æ",
    phoneme: "ae",
    Words: ["c<b>a</b>t"],
    Langs: 65535,
    AssignIds: [6128],
  },
  {
    Id: 223248,
    Img: "314/223248/pid-3140017-223248-408231253.gif",
    symbol: "ɝ",
    phoneme: "er",
    Words: ["b<b>ir</b>d"],
    Langs: 24608,
    AssignIds: [6134],
  },
  {
    Id: 223254,
    Img: "314/223254/pid-3140017-223254-408231258.gif",
    symbol: "ɔ",
    phoneme: "ao",
    Words: ["s<b>aw</b>"],
    Langs: 45068,
    AssignIds: [6138],
  },
  {
    Id: 223252,
    Img: "314/223252/pid-3140017-223252-408231256.gif",
    symbol: "Ʊ",
    phoneme: "uh",
    Words: ["b<b>oo</b>k"],
    Langs: 27375,
    AssignIds: [6126],
  },
  {
    Id: 223255,
    Img: "314/223255/pid-3140017-223255-408231259.gif",
    symbol: "ɑɪ",
    phoneme: "ay",
    Words: ["m<b>y</b>"],
    Langs: 45056,
    AssignIds: [6156],
  },
  {
    Id: 223246,
    Img: "314/223246/pid-3140017-223246-408231236.gif",
    symbol: "eɪ",
    phoneme: "ey",
    Words: ["s<b>a</b>y"],
    Langs: 56031,
    AssignIds: [6141],
  },
  {
    Id: 223086,
    Img: "314/223086/pid-3140017-223086-408231300.gif",
    symbol: "ɔɪ",
    phoneme: "oy",
    Words: ["b<b>oy</b>"],
    Langs: 45056,
    AssignIds: [6156],
  },
  {
    Id: 223251,
    Img: "314/223251/pid-3140017-223251-408231256.gif",
    symbol: "u",
    phoneme: "uw",
    Words: ["t<b>oo</b>"],
    Langs: 40960,
    AssignIds: [6150, 6126],
  },
  {
    Id: 223256,
    Img: "314/223256/pid-3140017-223256-408231300.gif",
    symbol: "ɑʊ",
    phoneme: "aw",
    Words: ["n<b>ow</b>"],
    Langs: 45056,
    AssignIds: [6156],
  },
  {
    Id: 222889,
    Img: "314/222889/pid-3140017-222889-408231235.gif",
    symbol: "I",
    phoneme: "ih",
    Words: ["s<b>i</b>t"],
    Langs: 61439,
    AssignIds: [6146],
  },
  {
    Id: 223253,
    Img: "314/223253/pid-3140017-223253-408231257.gif",
    symbol: "oʊ",
    phoneme: "ow",
    Words: ["n<b>o</b>"],
    Langs: 53248,
    AssignIds: [6138, 6150],
  },

  {
    Id: 223259,
    Img: "314/223259/pid-3140017-223259-408231302.gif",
    symbol: "b",
    phoneme: "b",
    Words: ["<b>b</b>ig"],
    Langs: 18881,
    AssignIds: [6125, 6139],
  },
  {
    Id: 223271,
    Img: "314/223271/pid-3140017-223271-408231314.gif",
    symbol: "l",
    phoneme: "l",
    Words: ["<b>l</b>eft"],
    Langs: 288,
    AssignIds: [6135],
  },
  {
    Id: 223260,
    Img: "314/223260/pid-3140017-223260-408231303.gif",
    symbol: "t",
    phoneme: "t",
    Words: ["<b>t</b>ip"],
    Langs: 4666,
    AssignIds: [6148, 6149],
  },
  {
    Id: 223277,
    Img: "314/223277/pid-3140017-223277-408231318.gif",
    symbol: "tʃ",
    phoneme: "ch",
    Words: ["<b>ch</b>air"],
    Langs: 61966,
    AssignIds: [6129, 6145],
  },
  {
    Id: 223278,
    Img: "314/223278/pid-3140017-223278-408231319.gif",
    symbol: "m",
    phoneme: "m",
    Words: ["<b>m</b>e"],
    Langs: 1216,
    AssignIds: [6136],
  },
  {
    Id: 223257,
    Img: "314/223257/pid-3140017-223257-408231311.gif",
    symbol: "θ",
    phoneme: "th",
    Words: ["<b>th</b>ink"],
    Langs: 65535,
    AssignIds: [6143, 6149],
  },
  {
    Id: 223261,
    Img: "314/223261/pid-3140017-223261-408231304.gif",
    symbol: "d",
    phoneme: "d",
    Words: ["<b>d</b>ay"],
    Langs: 2562,
    AssignIds: [6131, 6148],
  },
  {
    Id: 223279,
    Img: "314/223279/pid-3140017-223279-408231320.gif",
    symbol: "n",
    phoneme: "n",
    Words: ["<b>n</b>ew"],
    Langs: 192,
    AssignIds: [6136],
  },
  {
    Id: 223268,
    Img: "314/223268/pid-3140017-223268-408231312.gif",
    symbol: "ð",
    phoneme: "dh",
    Words: ["<b>th</b>is"],
    Langs: 65535,
    AssignIds: [6147, 6131],
  },
  {
    Id: 223265,
    Img: "314/223265/pid-3140017-223265-408231307.gif",
    symbol: "f",
    phoneme: "f",
    Words: ["<b>f</b>an"],
    Langs: 12577,
    AssignIds: [6132, 6140],
  },
  {
    Id: 223280,
    Img: "314/223280/pid-3140017-223280-408231320.gif",
    symbol: "ŋ",
    phoneme: "ng",
    Words: ["si<b>ng</b>"],
    Langs: 52942,
    AssignIds: [6136],
  },
  {
    Id: 223264,
    Img: "314/223264/pid-3140017-223264-408231306.gif",
    symbol: "v",
    phoneme: "v",
    Words: ["<b>v</b>an"],
    Langs: 29667,
    AssignIds: [6151, 6125, 6132],
  },
  {
    Id: 223263,
    Img: "314/223263/pid-3140017-223263-408231305.gif",
    symbol: "g",
    phoneme: "g",
    Words: ["<b>g</b>old"],
    Langs: 18881,
    AssignIds: [6130],
  },
  {
    Id: 223258,
    Img: "314/223258/pid-3140017-223258-408231301.gif",
    symbol: "p",
    phoneme: "p",
    Words: ["<b>p</b>ay"],
    Langs: 15130,
    AssignIds: [6139, 6140],
  },
  {
    Id: 223269,
    Img: "314/223269/pid-3140017-223269-408231313.gif",
    symbol: "w",
    phoneme: "w",
    Words: ["<b>w</b>e"],
    Langs: 22561,
    AssignIds: [6151],
  },
  {
    Id: 223273,
    Img: "314/223273/pid-3140017-223273-408231315.gif",
    symbol: "h",
    phoneme: "hh",
    Words: ["<b>h</b>ello"],
    Langs: 32808,
    AssignIds: [6133],
  },
  {
    Id: 223272,
    Img: "314/223272/pid-3140017-223272-408231315.gif",
    symbol: "r",
    phoneme: "r",
    Words: ["<b>r</b>ight"],
    Langs: 58848,
    AssignIds: [6135],
  },
  {
    Id: 223270,
    Img: "314/223270/pid-3140017-223270-408231314.gif",
    symbol: "j",
    phoneme: "y",
    Words: ["<b>y</b>es"],
    Langs: 546,
    AssignIds: [6152],
  },
  {
    Id: 223276,
    Img: "314/223276/pid-3140017-223276-408231318.gif",
    symbol: "dʒ",
    phoneme: "jh",
    Words: ["<b>j</b>ust"],
    Langs: 64973,
    AssignIds: [6152, 6129],
  },
  {
    Id: 223266,
    Img: "314/223266/pid-3140017-223266-408231310.gif",
    symbol: "s",
    phoneme: "s",
    Words: ["<b>s</b>ell"],
    Langs: 9010,
    AssignIds: [6142, 6144, 6143],
  },
  {
    Id: 223267,
    Img: "314/223267/pid-3140017-223267-408231311.gif",
    symbol: "z",
    phoneme: "z",
    Words: ["<b>z</b>oo"],
    Langs: 29666,
    AssignIds: [6153, 6144, 6147],
  },
  {
    Id: 223262,
    Img: "314/223262/pid-3140017-223262-408231304.gif",
    symbol: "k",
    phoneme: "k",
    Words: ["<b>c</b>old"],
    Langs: 4698,
    AssignIds: [6130],
  },
  {
    Id: 223274,
    Img: "314/223274/pid-3140017-223274-408231316.gif",
    symbol: "ʃ",
    phoneme: "sh",
    Words: ["<b>sh</b>e"],
    Langs: 41474,
    AssignIds: [6145, 6137, 6142],
  },
  {
    Id: 223275,
    Img: "314/223275/pid-3140017-223275-408231317.gif",
    symbol: "ʒ",
    phoneme: "zh",
    Words: ["mea<b>s</b>ure"],
    Langs: 45296,
    AssignIds: [6137, 6153],
  },
];

export const TROUBLE_PHONEME_BY_LANGUAGE = [
  [],
  [],
  [
    222969,
    223249,
    223252,
    223246,
    222889,
    6174,
    223265,
    223263,
    223276,
    223272,
    223257,
    223268,
    223264,
    223269,
    6177,
    6179,
    6162,
    6178,
  ],
  [
    222969,
    223247,
    223249,
    223252,
    223246,
    222889,
    223277,
    223261,
    223262,
    223280,
    223258,
    223274,
    223260,
    223257,
    223268,
    223264,
    223267,
    6177,
    6179,
    6155,
    6154,
    6162,
    6178,
  ],
  [
    222969,
    223249,
    223252,
    222889,
    6174,
    223277,
    223273,
    223276,
    223262,
    223258,
    223272,
    223260,
    223257,
    223268,
    6179,
    6155,
    6162,
    6178,
  ],
  [
    222969,
    223247,
    223249,
    223246,
    222889,
    6174,
    223262,
    223258,
    223260,
    223257,
    223268,
    223275,
    6177,
    6179,
    6155,
    6154,
    6162,
    6178,
  ],
  [
    222969,
    223255,
    223086,
    223256,
    223253,
    223249,
    223246,
    222889,
    6174,
    223273,
    223272,
    223257,
    223268,
    6155,
    6154,
    6178,
  ],
  [222969, 223254, 223249, 223252, 222889, 223277, 223276, 223280, 223258, 223257, 223268, 223267, 6155, 6154, 6162],
  [
    222969,
    223247,
    223249,
    222889,
    6174,
    223276,
    223262,
    223278,
    223280,
    223258,
    223272,
    223260,
    223257,
    223268,
    223269,
    6155,
    6162,
    6178,
  ],
  [
    222969,
    223249,
    223248,
    223252,
    223246,
    6174,
    223276,
    223280,
    223272,
    223257,
    223268,
    223269,
    6177,
    6179,
    6155,
    6154,
    6162,
    6178,
  ],
  [222969, 223249, 223252, 223246, 222889, 6174, 223276, 223280, 223258, 223272, 223257, 223268, 223269, 6162],
  [
    223250,
    222969,
    223249,
    223248,
    223252,
    222889,
    6174,
    223265,
    223271,
    223272,
    223260,
    223257,
    223268,
    223264,
    223269,
    223275,
    6179,
    6155,
    6154,
    6162,
    6178,
  ],
  [
    222888,
    222969,
    223247,
    223252,
    223246,
    222889,
    6174,
    223259,
    223263,
    223276,
    223280,
    223272,
    223257,
    223268,
    223264,
    223267,
    223275,
    6177,
    6179,
    6155,
    6154,
    6162,
    6178,
  ],
  [
    222969,
    223249,
    222889,
    6174,
    223259,
    223265,
    223263,
    223276,
    223272,
    223257,
    223268,
    223264,
    223267,
    6177,
    6179,
    6155,
    6154,
    6162,
    6178,
  ],
  [
    223250,
    222969,
    223254,
    223253,
    223247,
    223246,
    223277,
    223265,
    223262,
    223258,
    223260,
    223257,
    223268,
    223264,
    223269,
    223267,
    223275,
    6177,
    6179,
    6155,
    6154,
    6178,
  ],
  [
    222888,
    222969,
    223254,
    223247,
    223249,
    223248,
    223252,
    222889,
    223277,
    223265,
    223276,
    223258,
    223272,
    223274,
    223257,
    223268,
    223264,
    223269,
    223267,
    223275,
    6155,
  ],
];

export const LANGUAGE_CODES = [
  { id: 0, title: "My Sounds" },
  { id: 1, title: "Select a language" },
  { id: 2, title: "German" },
  { id: 3, title: "Spanish" },
  { id: 4, title: "French" },
  { id: 5, title: "Italian" },
  { id: 6, title: "Polish" },
  { id: 7, title: "Portuguese (Brazil)" },
  { id: 8, title: "Russian" },
  { id: 9, title: "Czech" },
  { id: 10, title: "Turkish" },
  { id: 11, title: "Japanese" },
  { id: 12, title: "Chinese" },
  { id: 13, title: "Korean" },
  { id: 14, title: "Indian languages" },
  { id: 15, title: "Tagalog" },
];

export const GET_MY_SOUND = "GET_MY_SOUND";
export const GET_MY_SOUND_SUCCESS = "GET_MY_SOUND_SUCCESS";
export const GET_MY_SOUND_FAIL = "GET_MY_SOUND_FAIL";
